<div class="graph-container">
  <div class="header">
    <span class="name">{{ data.name ?? ('DASHBOARD.TYPE_GRAPH' | translate) }}</span>
    <app-uplot-range-picker [currentRange]="range" (rangeHasChanged)="changeRange($event)">
    </app-uplot-range-picker>
  </div>

  @if (range) {
    <div class="graph">
      @if (!noData) {
        <app-heat-map
          (rangeChanged)="changeRange($event, true)"
          [displayedRange]="range"
          [data]="getData"
          [refresh$]="graphRefresh$"
          [seriesConfig$]="seriesConfig$"
          (graphLoaded)="itemLoaded()"
        ></app-heat-map>
      } @else {
        <p class="no-data">{{ 'INSPECT.NO_DATA' | translate }}</p>
      }
    </div>
  }
</div>
